// LOAD-BEARING SIDE-EFFECT IMPORT — do not delete as "unused".
//
// Before the carve this file imported an api fn from `@/pages/api/scribeAPIV2`,
// and that import was doing a second job nobody had written down: it pulled in
// `@/utils/scribeHTTP` -> `@/store` -> `src/models/index.ts`, which INITIALISED
// the Rematch model cluster. Consumers further along an import chain relied on
// that ordering. Replacing the import with a package specifier removed the
// warm-up and eleven suites died with `ReferenceError: Cannot access 'auth'
// before initialization` — the `authModel` -> `scribeAPI` -> `getDomains` ->
// `store` -> `models/index` -> `authModel` cycle, resolved only because
// something used to touch it first.
//
// Keeping the specifier as a side-effect import restores the exact pre-carve
// module-init order at zero runtime cost. It retires with the Z2 codemod, when
// the cycle itself goes.
import '@/pages/api/scribeAPIV2';

// Delegate shim. Carved to `@heidi/integrations/connected-apps/data` at
// ARCFE-1087 — headless, so the delegate dissolves to a pure re-export. The
// path is kept because the capability-driven push-button suites and
// `useIntegrationCapabilityResolver` mock it by this literal.
export { useQueryIntegrationCapabilities } from '@heidi/integrations/connected-apps/data';
